var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDevtoolIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 14,
  viewBox: "0 0 19 14"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_1777",
  "data-name": "Group 1777",
  transform: "translate(-59 -243)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_22",
  "data-name": "Path 22",
  d: "M4.692-8.815l-2.675.98,2.675.972v1L.868-7.313V-8.357L4.692-9.812Zm2.876-2.973H8.685L6.034-4.22H4.917Zm5.086,3.431v1.044L8.83-5.859v-1l2.675-.972L8.83-8.815v-1Z",
  transform: "translate(61.739 258.004)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_1032",
  "data-name": "Rectangle 1032",
  transform: "translate(59 243)",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8
}, /*#__PURE__*/React.createElement("rect", {
  width: 19,
  height: 14,
  rx: 1.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.9,
  y: 0.9,
  width: 17.2,
  height: 12.2,
  rx: 0.6,
  fill: "none"
})))));
export { SvgDevtoolIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/devtoolIcon.c608ffbc5d2ab3ba43a06acef8663cd7.svg";